import { useAuth0 } from '@auth0/auth0-react'

export const useLogout = () => {
  const { logout } = useAuth0()

  const LOCALSTORAGE_KEY_PREFIX = '@@auth'

  return {
    logout: () => {
      // Auth0 logout
      logout({ logoutParams: { returnTo: window.location.origin } })

      // clear local storage items
      for (let i = 0; i < window.localStorage.length; i++) {
        const key = window.localStorage.key(i)
        if (key?.startsWith(LOCALSTORAGE_KEY_PREFIX)) {
          window.localStorage.removeItem(key)
        }
      }
    },
  }
}
